import i18n from "src/i18n"
import { DoctorTabs, Lookup } from "./Common.Type"

export const ROLES = {
    SUPER_ADMIN: 1,
    DOCTOR: 8,
    PHARMASIST: 9
}


export const Localizer = <T extends Lookup>(List: T[]) => List.map(item => ({ ...item, label: i18n.t(item?.label) }))


export const REQUEST_STATUS = {

    return: 9

}

export const RepeatedDoses = Localizer([
    //@ts-ignore
    { label: "daily", repeat: 30, value: 1 },
    //@ts-ignore
    { label: "weekly", repeat: 4, value: 7 },
    //@ts-ignore
    { label: "monthly", repeat: 1, value: 30 },
])

export const userDose = Localizer([
    { label: "daily", value: 1 },
    { label: "daily-by-day", value: 2 },
    { label: "twice-a-week", value: 3 },
    { label: "once-a-week", value: 4 },
    { label: "once-a-month", value: 5 },

])




export const ALLOW_FOR_PRINT_STATUES = {

    Printted: 2,
    Packed: 3,
    SubmittedToShippingCompan: 4,
    UnderDistribution: 32,
    ReturnedToHospital: 9,
    ManualReceiveByPatient: 11,
    DeliveredToPatient: 33,
    RefusedDelivery: 34,
    WaitingForPacking: 52
}


export const ALOWED_LIST_STATUS_FOR_PRINT = [
    ALLOW_FOR_PRINT_STATUES?.Printted,
    ALLOW_FOR_PRINT_STATUES?.Packed,
    ALLOW_FOR_PRINT_STATUES?.SubmittedToShippingCompan,
    ALLOW_FOR_PRINT_STATUES?.UnderDistribution,
    ALLOW_FOR_PRINT_STATUES?.ReturnedToHospital,
    ALLOW_FOR_PRINT_STATUES?.ManualReceiveByPatient,
    ALLOW_FOR_PRINT_STATUES?.DeliveredToPatient,
    ALLOW_FOR_PRINT_STATUES?.RefusedDelivery,
    ALLOW_FOR_PRINT_STATUES?.WaitingForPacking
]


export const PrintStatus = 11

export const CONTROLLER_NAMES = {

    MedicinePacking: 11,// same controller
    Receivingreturns: 12,// same controller
    PatientMedicines: 13,
    MobRequestStatus: 14,
    MobManualRequests: 15,
    DoctorApprovalRequests: 21, // same controller
    ChangeMedicinesRequestsDoctor: 23, // same controller
    MobPatientMedicalServices: 42,
    MobRecurringRequests: 58,
    MobDiagnosRequests: 59,
    WaitingForPacking: 72,


}


export const IsRequestStatusAllowed = (id: number) => ALOWED_LIST_STATUS_FOR_PRINT.includes(id)


export const DELIVRY_TABS = {
    UpComing: 1,
    Delayed: 2,
    All: 3,

}

export const DELIVRY_TABS_MAP = Localizer([
    { label: "All", value: DELIVRY_TABS?.All },
    { label: "upComing", value: DELIVRY_TABS?.UpComing },
    { label: "delayed", value: DELIVRY_TABS?.Delayed },
])



// Doctor screens 

export const TabsIDs: DoctorTabs = {
    PatientPlan: 1,
    OrderReview: 2,
    ChangeRequest: 3,
}

export const Header_screen_Tabs = [
    {
        name: "Patient's Plan",
        icon: "tabler:pill",
        id: TabsIDs.PatientPlan
    },
    {
        name: "Order Review",
        icon: "tabler:clipboard-list",
        id: TabsIDs.OrderReview
    },
    {
        name: "Change Requests",
        icon: "lucide:git-pull-request",
        id: TabsIDs.ChangeRequest
    }
]

export const Doctor_Tabs = {

    [TabsIDs.PatientPlan]: {
        name: "Patient's Plan",
        desc: "Search for a patient to manage their medication.",
        icon: "tabler:pill",
    },
    [TabsIDs.OrderReview]: {
        name: "Order Review",
        desc: "Review and approve pending orders from pharmacists.",
        icon: "tabler:clipboard-list",
    },
    [TabsIDs.ChangeRequest]: {
        name: "Change Requests",
        desc: "Review medication change requests from pharmacists.",
        icon: "lucide:git-pull-request",
    }
}

// End Doctor screens



export const PAGES_NAMES = { // TO BE CHANGED
    User: 1,
    Role: 2,
    District: 5,
    Mill: 6,
    Bakery: 7,
    Batch: 11,
    ProductionLine: 12,
    Packets: 15,
    CustodyArchive: 16,
    UsersStatics: 17,
    PacketsStatics: 18,
    WorkplacesStatics: 19,
}

export const DATETIME_TYPES = {
    TimeOnly: 1,
    DateOnly: 2,
    FullDate: 3
}

export const LANGAUAGE = {
    English: 1,
    Arabic: 2,
    Both: 3
}

export const USER_SEARCH = {
    DROPDOWN: 1,
    DATEPICKER: 2,

}

export const DROP_DOWN_LIMIT = 50

export const USER_SEARCH_TYPE = {
    [USER_SEARCH.DROPDOWN]: 'DropDown',
    [USER_SEARCH.DATEPICKER]: 'Date',

}

export const WorkplaceType = {
    Shipping_Company: 1,
    Mill: 2,
    Bakery: 3,
    Print_Shop: 4
}


export const ACTIVE_SELECT_OPTIONS = [
    { label: "active", value: 1 },
    { label: "not-active", value: 0 },
]

export const TRUTHY_SELECT_OPTIONS_COLOR_MAP = {
    true: { text: "#33a02c", bg: "#e8f5e9" },
    false: { text: "#e31a1c", bg: "#ffebee" },
};


export const monthMapper = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
};


export const ParentHospitalConfigurations = {
    IsApplyInvoicePrint: "IsApplyInvoicePrint",
    RestrictPeriodAmount: "RestrictPeriodAmount",
    AllowMedicalServices: "AllowMedicalServices",
    AllowPatientTypeUpdates: "AllowPatientTypeUpdates",
    ResritctMedicineAllDecisionPeriod: "ResritctMedicineAllDecisionPeriod",
    PossibilityMakingAltMedicineEssential: "PossibilityMakingAltMedicineEssential",
    AllowSplitCoolingMedicinesToSeparateReceipt: "AllowSplitCoolingMedicinesToSeparateReceipt",
    AllowToDispenseMedicinesForMoreThanOneMonthInOneRequest: "AllowToDispenseMedicinesForMoreThanOneMonthInOneRequest"
}

export const DecisionTypes = {
    Normal: 1,
    Fake: 2,
    Combined: 3,
};

export const BOOLEAN_COLOR_MAP = {
    true: { text: "#33a02c", bg: "#e8f5e9" },
    false: { text: "#e31a1c", bg: "#ffebee" },
    null: { text: "#e31a1c", bg: "#ffebee" },
};

export const STATUS_COLOR_MAP = {
    1: { text: "#ff9d00", bg: "#fff9c4" },
    2: { text: "#33a02c", bg: "#e8f5e9" },
    3: { text: "#e31a1c", bg: "#ffebee" },
    4: { text: "#757575", bg: "#f5f5f5" },
    5: { text: "#b71c1c", bg: "#ffebee" },
    6: { text: "#1565c0", bg: "#e3f2fd" },
    7: { text: "#6a1b9a", bg: "#f3e5f5" },
    8: { text: "#f57f17", bg: "#fff8e1" },
    10: { text: "#5e35b1", bg: "#ede7f6" },
};

export const REQUEST_STATUS_COLOR_MAP = {
    1: { text: "#1565c0", bg: "#e3f2fd" },
    2: { text: "#1f78b4", bg: "#e3f2fd" },
    3: { text: "#ff9d00", bg: "#fffde7" },
    4: { text: "#33a02c", bg: "#e8f5e9" },
    5: { text: "#e31a1c", bg: "#ffebee" },
    6: { text: "#fdbf6f", bg: "#fff3e0" },
    7: { text: "#ff7f00", bg: "#fff3e0" },
    8: { text: "#cab2d6", bg: "#f3e5f5" },
    9: { text: "#6a3d9a", bg: "#f3e5f5" },
    10: { text: "#b15928", bg: "#efebe9" },
    11: { text: "red", bg: "#ffebee" },
    32: { text: "green", bg: "#e8f5e9" },
    33: { text: "orange", bg: "#fff3e0" },
    34: { text: "silver", bg: "#f5f5f5" },
    35: { text: "#9561e2", bg: "#ede7f6" },
    36: { text: "#6574cd", bg: "#e8eaf6" },
    37: { text: "#4dc0b5", bg: "#e0f2f1" },
    38: { text: "#e3342f", bg: "#ffebee" },
    39: { text: "#f6993f", bg: "#fff3e0" },
    40: { text: "#e48472", bg: "#fbe9e7" },
    41: { text: "#794c4a", bg: "#efebe9" },
    42: { text: "#881d2d", bg: "#ffebee" },
};

export const PreparationStatus = {
    NotDefinedYet: 1,
    preparedInTime: 2,
    late: 3,
    scheduledForNextPickup: 4,
    patientDecidedToReceiveManually: 5,
}

export const PreparationStatusOptions = [
    { label: "notDefinedYet", value: PreparationStatus.NotDefinedYet },
    { label: "preparedInTime", value: PreparationStatus.preparedInTime },
    { label: "late", value: PreparationStatus.late },
    { label: "scheduledForNextPickup", value: PreparationStatus.scheduledForNextPickup },
    { label: "patientDecidedToReceiveManually", value: PreparationStatus.patientDecidedToReceiveManually },
]

export const PreparationStatusColorMap = {
    [PreparationStatus.preparedInTime]: { text: "#757575", bg: "#f5f5f5" },
    [PreparationStatus.preparedInTime]: { text: "#0088FE", bg: "#e3f2fd" },
    [PreparationStatus.late]: { text: "#757575", bg: "#f5f5f5" },
    [PreparationStatus.scheduledForNextPickup]: { text: "#33a02c", bg: "#e8f5e9" },
    [PreparationStatus.patientDecidedToReceiveManually]: { text: "#6a1b9a", bg: "#f3e5f5" },
}

export const ALLOWED_MONTHS_TO_COVER = [
    { label: "oneMonth", value: 1 },
    { label: "twoMonth", value: 2 },
    { label: "threeMonth", value: 3 }
]

export const ActionsId = 1